import validate from "validate.js";

const formPresenceMessage = (attribute) => `^${attribute} cant be empty.`;
const constraints = {
  displayName: {
    presence: {
      message: formPresenceMessage("Name"),
      allowEmpty: false,
    },
  },
  gpsLocation: {
    format: {
      pattern: "([-]*[0-9]+.[0-9]+ [-]*[0-9]+.[0-9]+)*",
      message: "^GPS location should be entered as decimal degrees (DD) without a comma between latitude and longitude and include all numbers following the decimal place (ex. 1.2222 -1.2222 or 1.222222 1.222222)",
      allowEmpty: true,
    },
  },
};

const validateForm = ({ displayName, gpsLocation }) => {
  const errors = validate(
    {
      displayName,
      gpsLocation,
    },
    constraints
  );
  return errors;
};

export default validateForm;
